import { render, staticRenderFns } from "./Empleados.vue?vue&type=template&id=b8e34a98&scoped=true"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"
import style0 from "./Empleados.vue?vue&type=style&index=0&id=b8e34a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e34a98",
  null
  
)

export default component.exports